import { render, staticRenderFns } from "./LayoutPweb.vue?vue&type=template&id=cd9829ce"
import script from "./LayoutPweb.vue?vue&type=script&lang=js"
export * from "./LayoutPweb.vue?vue&type=script&lang=js"
import style0 from "../../leiloes/components/leilao.styl?vue&type=style&index=0&prod&lang=stylus&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports